export default "__VITE_ASSET__95a1e55b__"